/* Internationalization JS */
define(['jquery', 'c21/internationalization.esp'], function ($) {
   "use strict";

   var items = {},
      websiteCode = window.websiteCode;

   function isEsp () {
      return ((websiteCode !== null && websiteCode !== "" && websiteCode === "ECO_ESP") || (window.location.pathname.indexOf("/esp/") === 0));
   }
   
   /* Load strings from JSON file*/
   function initialize() {
      if (isEsp()) {
         $.each( window.espInternationalization, function( key, val ) {          
            items[key] = val;
         });
      }
   }

   /* Returns the stored value if any for passed in key */
   function getString (key) {
      if (isEsp()) {
         if (key === null || key === "") {
            return key;
         }

         if (items[key] !== "" && items[key] !== "undefined" && items[key] !== undefined) {
             return items[key];
         } 
      }

      return key;
   }
   
   /* Translate */
   function translate(from, to, text, callback) {
      var url = "/intltranslator.c21?from=" + from + "&to=" + to + "&text=" + text;
      
      $.getJSON( url, {
         format: "json"
      }).done(function( data ) {
         callback(data.result);
      });      
   }  
   
   /* Translate Property Description */
   function translatePropertyDesc(from, to, pid, callback) {
      var url = "/intltranslator.c21?from=" + from + "&to=" + to + "&pid=" + pid + "&field=0";
      
      $.getJSON( url, {
         format: "json"
      }).done(function( data ) {
         callback(data.result);
      });      
   }     

   /* Translate Agent Profile */
   function translateAgentProfile(from, to, aid, callback) {
      var url = "/intltranslator.c21?from=" + from + "&to=" + to + "&aid=" + aid + "&field=1";
      
      $.getJSON( url, {
         format: "json"
      }).done(function( data ) {
         callback(data.result);
      });      
   }     

   /* Translate Office Profile */
   function translateOfficeProfile(from, to, oid, callback) {
      var url = "/intltranslator.c21?from=" + from + "&to=" + to + "&oid=" + oid + "&field=2";
      
      $.getJSON( url, {
         format: "json"
      }).done(function( data ) {
         callback(data.result);
      });      
   }     

   initialize();
   
   return {
      getString : getString,
      translate: translate,
      translatePropertyDesc: translatePropertyDesc,
      translateAgentProfile: translateAgentProfile,
      translateOfficeProfile: translateOfficeProfile
   };
});
